import axios from 'axios';
import { API_BASE_URL } from '../config/api';

class HeatmapDataService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add token to requests
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('googleAccessToken') || sessionStorage.getItem('googleAccessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  /**
   * Save heatmap/grid point data to database
   */
  async saveHeatmapData(data) {
    try {
      const response = await this.api.post('/heatmap-data/save', data);
      return response.data;
    } catch (error) {
      console.error('[HeatmapDataService] Error saving heatmap data:', error);
      throw error;
    }
  }

  /**
   * Get latest heatmap data for a user
   */
  async getLatest(userId, params = {}) {
    try {
      console.log('[HeatmapDataService] Calling getLatest:', { userId, params });
      const response = await this.api.get(`/heatmap-data/latest/${userId}`, { params });
      console.log('[HeatmapDataService] getLatest response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[HeatmapDataService] Error fetching latest heatmap data:', error);
      console.error('[HeatmapDataService] Error response:', error.response?.data);
      console.error('[HeatmapDataService] Error status:', error.response?.status);
      // Return error info instead of throwing to prevent page crashes
      return {
        success: false,
        error: error.response?.data?.error || error.message,
        errorType: error.response?.data?.errorType || 'NetworkError',
        status: error.response?.status
      };
    }
  }

  /**
   * Get heatmap data history for a user
   */
  async getHistory(userId, params = {}) {
    try {
      console.log('[HeatmapDataService] Calling getHistory:', { userId, params });
      const response = await this.api.get(`/heatmap-data/history/${userId}`, { params });
      console.log('[HeatmapDataService] getHistory response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[HeatmapDataService] Error fetching heatmap history:', error);
      console.error('[HeatmapDataService] Error response:', error.response?.data);
      console.error('[HeatmapDataService] Error status:', error.response?.status);
      // Return error info instead of throwing to prevent page crashes
      return {
        success: false,
        error: error.response?.data?.error || error.message,
        errorType: error.response?.data?.errorType || 'NetworkError',
        status: error.response?.status
      };
    }
  }

  /**
   * Get heatmap data by location ID
   */
  async getByLocationId(userId, locationId) {
    try {
      const response = await this.api.get(`/heatmap-data/location/${userId}/${locationId}`);
      return response.data;
    } catch (error) {
      console.error('[HeatmapDataService] Error fetching heatmap data by location:', error);
      throw error;
    }
  }

  /**
   * Delete heatmap data record
   */
  async deleteHeatmapData(id) {
    try {
      const response = await this.api.delete(`/heatmap-data/${id}`);
      return response.data;
    } catch (error) {
      console.error('[HeatmapDataService] Error deleting heatmap data:', error);
      throw error;
    }
  }
}

export default new HeatmapDataService();
